import React, { useState } from 'react'
import styled from 'styled-components'
import { FaPinterest, FaFacebookSquare, FaInstagram } from 'react-icons/fa'
import { BsHouseDoorFill } from 'react-icons/bs'
import { BiLinkExternal } from 'react-icons/bi'
import { PublicPortfolioButton } from './MessageHandler'
import { FaStar } from 'react-icons/fa'
import { useAppContext } from 'context/AppContext'
import { PUBLIC_LINK_BASE, isLegacyUser } from 'variables/general'
import { profilePageIcons } from 'components/admin/Images'
import ReactGA from 'react-ga'
import placeholder from 'assets/img/brand/Start_Creating_Rev1.jpg'
import CoverImageUpload from 'components/images/CoverImageUpload'
import ImageUpload from 'components/images/ImageUpload'
import { SpinLoader } from 'components/Loader/SpinLoader'

const { CameraIcon, headerCoverPhoto } = profilePageIcons

const PortfolioHeader = (props) => {
  const { locationPage, setProfilePicUploaded } = props
  const [loading, setLoading] = useState(false)
  const [context] = useAppContext()

  return (
    <Container font={props.font}>
      <ImgWrap>
        <Img
          src={props.coverPhoto || headerCoverPhoto}
          alt={`portfolio by ${props.photographer.name} cover image`}
        />
        {loading && locationPage === 'profile' && (
          <AvtarLoader>
            <SpinLoader size={50} />{' '}
          </AvtarLoader>
        )}
      </ImgWrap>
      {window.innerWidth > 1000 ? (
        <SubContainer1>
          <AvatarWrap>
            <ImageUpload
              round
              image={
                props.photographer.displayImage ||
                (locationPage === 'profile' ? headerCoverPhoto : placeholder)
              }
              imageName="displayImage"
              testid="edit-display-image"
              locationPage={props.locationPage}
              uploaded={() => (locationPage === 'profile' ? setProfilePicUploaded : {})}
              icon={CameraIcon}
              uploadedImage={context.photographer.displayImage}
            />
          </AvatarWrap>
          <Col1>
            {props.setCoverImageUploaded && (
              <CoverImageUpload
                testid="edit-portfolio-header-image"
                image={
                  (context.photographer.coverImage?.length && context.photographer.coverImage[0].thumbnail) ||
                  placeholder
                }
                uploaded={props.setCoverImageUploaded}
                setLoading={setLoading}
                loading={loading}
                hideImage
              />
            )}
            <H1>{props.photographer.companyName}</H1>
            <Row1 font={props.secondaryFont ? props.secondaryFont : props.font}>
              <H2>{props.photographer.location ? props.photographer.location.name : 'Victoria, BC'}</H2>
              {props.photographer.review && (
                <OutboundLink
                  eventLabel={`${props.photographer.companyName} Review clicked - ${props.photographer?.review?.url}`}
                  to={`${props.photographer?.review?.url}`}
                  target="_blank"
                  rel="noopener"
                  trackerNames={['reviews']}
                  key={props.photographer.review}
                >
                  <SubRow>
                    <H3> | {props.photographer?.review?.rating}/5.0 </H3>
                    <StarIcon />
                    <H3> {props.photographer?.review?.number} Reviews</H3>
                  </SubRow>
                </OutboundLink>
              )}
            </Row1>
          </Col1>
          <Col2>
            <ButtonWrapper>
              {props.location === 'admin' &&
                isLegacyUser(context) &&
                !!context.photographer.nextCustomDomain(
                  <ViewLiveButton
                    href={`${PUBLIC_LINK_BASE(context.photographer)}/portfolio/${
                      context.user.photographer.identifier
                    }/`}
                    rel="noopener"
                    target="_blank"
                    font={props.secondaryFont ? props.secondaryFont : props.font}
                  >
                    <LinkIcon />
                    View Live Page
                  </ViewLiveButton>,
                )}
              <PublicPortfolioButton
                companyName={props.photographer.companyName}
                buttonTitle={'Message'}
                option={'message'}
                photographerID={props.photographer.identifier}
                interest={window.location.pathname}
                font={props.secondaryFont ? props.secondaryFont : props.font}
              />
            </ButtonWrapper>
            {!!props.photographer.socials && !!props.photographer.socials.length && (
              <SocialIcons>
                {props.photographer.socials.map((social) => (
                  <OutboundLink
                    eventLabel={`${props.photographer.companyName} ${social.socialSite.name} Icon clicked - ${social.url}`}
                    to={`${social.url}`}
                    target="_blank"
                    rel="noopener"
                    trackerNames={['socialLinkIcon']}
                    key={social.socialSite.name}
                  >
                    <A href={`${social.url}`} rel="noopener" target="_blank" key={social.socialSite.name}>
                      {social.socialSite.name === 'Website' && <WebSite />}
                      {social.socialSite.name === 'Instagram' && <Instagram />}
                      {social.socialSite.name === 'Facebook' && <Facebook />}
                      {social.socialSite.name === 'Pinterest' && <Pinterest />}
                    </A>
                  </OutboundLink>
                ))}
              </SocialIcons>
            )}
          </Col2>
        </SubContainer1>
      ) : (
        <SubContainer2>
          {props.setCoverImageUploaded && (
            <CoverImageUpload
              testid="edit-portfolio-header-image"
              image={
                (context.photographer.coverImage?.length && context.photographer.coverImage[0].thumbnail) ||
                placeholder
              }
              uploaded={props.setCoverImageUploaded}
              setLoading={setLoading}
              loading={loading}
              hideImage
            />
          )}
          <AvatarWrap>
            <ImageUpload
              round
              image={
                props.photographer.displayImage ||
                (locationPage === 'profile' ? headerCoverPhoto : placeholder)
              }
              imageName="displayImage"
              testid="edit-display-image"
              uploaded={() => (locationPage === 'profile' ? setProfilePicUploaded : {})}
              icon={CameraIcon}
              locationPage={props.locationPage}
              uploadedImage={context.photographer.displayImage}
            />
          </AvatarWrap>
          {!!props.photographer.socials && !!props.photographer.socials.length && (
            <SocialIcons>
              {props.photographer.socials.map((social) => (
                <OutboundLink
                  eventLabel={`${props.photographer.companyName} ${social.socialSite.name} Icon clicked - ${social.url}`}
                  to={`${social.url}`}
                  target="_blank"
                  rel="noopener"
                  trackerNames={['socialLinkIcon']}
                  key={social.socialSite.name}
                >
                  <A>
                    {social.socialSite.name === 'Website' && <WebSite />}
                    {social.socialSite.name === 'Instagram' && <Instagram />}
                    {social.socialSite.name === 'Facebook' && <Facebook />}
                    {social.socialSite.name === 'Pinterest' && <Pinterest />}
                  </A>
                </OutboundLink>
              ))}
            </SocialIcons>
          )}
          <H1>{props.photographer.companyName}</H1>
          <Row1 font={props.secondaryFont ? props.secondaryFont : props.font}>
            <H2>{props.photographer.location ? props.photographer.location.name : 'Victoria, BC'}</H2>
            {props.photographer.review && (
              <OutboundLink
                eventLabel={`${props.photographer.companyName} Review clicked - ${props.photographer?.review?.url}`}
                to={`${props.photographer?.review?.url}`}
                target="_blank"
                rel="noopener"
                trackerNames={['reviews']}
                key={props.photographer.review}
              >
                <SubRow>
                  <H3> | {props.photographer?.review?.rating}/5.0 </H3>
                  <StarIcon />
                  <H3> {props.photographer?.review?.number} Reviews</H3>
                </SubRow>
              </OutboundLink>
            )}
          </Row1>

          <ButtonWrapper>
            {props.location === 'admin' && isLegacyUser(context) && (
              <ViewLiveButton
                href={`${PUBLIC_LINK_BASE(context.photographer)}/portfolio/${
                  context.user.photographer.identifier
                }/`}
                rel="noopener"
                target="_blank"
                font={props.secondaryFont ? props.secondaryFont : props.font}
              >
                <LinkIcon />
                View Live Page
              </ViewLiveButton>
            )}
            <PublicPortfolioButton
              companyName={props.photographer.companyName}
              buttonTitle={'Message'}
              option={'message'}
              isMarginBottom={20}
              photographerID={props.photographer.identifier}
              interest={window.location.pathname}
              font={props.secondaryFont ? props.secondaryFont : props.font}
            />
          </ButtonWrapper>
        </SubContainer2>
      )}
    </Container>
  )
}

export default PortfolioHeader

const Container = styled.div`
  position: relative;
  width: 100%;
  margin: 0;
  background: black;
  height: 260px;
  font-size: 10px;
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
  color: white;
  margin: 0 0 70px 0;
  font-family: ${(props) => props.font};
  @media (max-width: 1000px) {
    margin-bottom: 10px;
    height: 400px;
  }
  @media (max-width: 400px) {
    font-size: 9px;
  }
  @media (max-width: 360px) {
    font-size: 8px;
  }
`

const SubContainer1 = styled.div`
  position: relative;
  height: 100%;
  width: 90vw;
  display: flex;
  justify-content: space-between;
`
const SubContainer2 = styled.div`
  position: relative;
  height: 100%;
  width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  // justify-content: space-evenly;
`
const ImgWrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`
const AvtarLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  @media (max-width: 1000px) {
    margin-top: 50px;
  }
`

const Img = styled.img`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  object-fit: cover;
  opacity: 0.7;
  @media (max-width: 1000px) {
    height: 100%;
  }
`
const AvatarWrap = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  border-radius: 999px;
  // background: white;
  @media (max-width: 1000px) {
    top: 0%;
  }
`

const SocialIcons = styled.div`
  position: relative;
  display: inline-block;
  font-size: 2.8em;
  z-index: 2;
  @media (max-width: 1100px) {
    position: absolute;
    top: 15px;
    right: 15px;
  }
`

const Facebook = styled(FaFacebookSquare)`
  margin: 0 15px 0 0;
`

const Instagram = styled(FaInstagram)`
  margin: 0 15px 0 0;
`

const WebSite = styled(BsHouseDoorFill)`
  margin: 0 15px 0 0;
`

const Pinterest = styled(FaPinterest)`
  margin: 0 15px 0 0;
`

const Col1 = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  padding: 0 0 30px 30px;
  max-width: 40vw;
  @media (max-width: 1250px) and (min-width: 1150.02px) {
    max-width: 42vw;
  }
  @media (max-width: 1150px) and (min-width: 1000.02px) {
    max-width: 40vw;
  }
  @media (max-width: 1000px) and (min-width: 900.02px) {
    max-width: 40vw;
  }
  @media (max-width: 900px) {
    max-width: 100vw;
  }
`

const Col2 = styled.div`
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  justify-content: space-between;
  height: 100%;
  width: 40%;
  padding: 30px;
  @media (max-width: 1400px) {
    padding: 2em;
  }
`
const A = styled.div`
  position: relative;
  display: inline-block;
  &:hover {
    opacity: 0.8;
  }
`
const H1 = styled.div`
  position: relative;
  margin: 0 0 12px 0;
  padding: 0;
  font-weight: 600;
  font-size: 4em;
  text-align: left;
  cursor: pointer;
  @media (max-width: 1250px) {
    font-size: 3em;
  }
  @media (max-width: 1150px) {
    font-size: 2.8em;
  }
  @media (max-width: 1000px) {
    font-size: 2.6em;
  }
  @media (max-width: 900px) {
    margin: 0.5em 0 0.2em 0;
    font-size: 2.6em;
  }
  @media (max-width: 550px) {
    margin: 0.7em 0 0.2em 0;
    font-size: 2.2em;
  }
`
const H2 = styled.div`
  position: relative;
  font-size: 1.6em;
  @media (max-width: 550px) {
    font-size: 1.4em;
    margin: 0 0 4px 0;
  }
  font-weight: 600;
  margin: 0;
`

const H3 = styled.div`
  position: relative;
  margin: 0 6px;
  padding: 0;
  font-weight: 600;
  font-size: 1.6em;
  @media (max-width: 550px) {
    font-size: 1.4em;
  }
`

const Row1 = styled.div`
  position: relative;
  display: flex;
  font-family: ${(props) => !!props.font && props.font};
`

const StarIcon = styled(FaStar)`
  font-size: 1.7em;
  padding: 0;
  cursor: pointer;
`

const SubRow = styled.div`
  position: relative;
  display: flex;
  cursor: pointer;
`
const ViewLiveButton = styled.a`
  position: relative;
  letter-spacing: 0.5px;
  font-size: 1.4em;
  font-family: ${(props) => !!props.font && props.font};
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  height: 3em;
  border: none;
  padding: 0;
  text-transform: none;
  outline: none;
  color: var(--black);
  background: white;
  width: 11em;
  margin: 0.5em 1em;
  @media (max-width: 1400px) {
    margin: 0.5em 0.4em;
    padding: 0.2em 0.6em;
  }
  @media (max-width: 1150px) {
    font-size: 1.2em;
  }
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const LinkIcon = styled(BiLinkExternal)`
  font-size: 16px;
  margin: 0.1em 0.5em 0 0;
`
const OutboundLink = styled(ReactGA.OutboundLink)`
  text-decoration: none;
`
